module.exports = __webpack_public_path__ + "img/avatar_default.68f2f6f9.png";